// Alpha VesselCo LLC spotter aircraft fleet
// All registered c/o Ocean Fleet Services, 610 Menhaden Rd, Reedville VA 22539
// Source: FAA Releasable Aircraft Database, retrieved March 2026
// These aircraft are the active spotter fleet for Omega Protein / Cooke Inc.
// Atlantic menhaden reduction operations out of Reedville, VA

export const spotterFleet = [
  { ident: 'N182JD',  year: 2000, model: 'Cessna 182S'   },
  { ident: 'N212BG',  year: 1980, model: 'Cessna 172RG'  },
  { ident: 'N22JN',   year: 1979, model: 'Cessna 172RG'  },
  { ident: 'N2376R',  year: 1999, model: 'Cessna 182S'   },
  { ident: 'N268ME',  year: 2000, model: 'Cessna 182S'   },
  { ident: 'N3552Q',  year: 2001, model: 'Cessna 182T'   },
  { ident: 'N447ES',  year: null, model: 'Cessna 182S'   },
  { ident: 'N4666V',  year: 1980, model: 'Cessna 172RG'  },
  { ident: 'N4861V',  year: 1980, model: 'Cessna 172RG'  },
  { ident: 'N4956V',  year: 1980, model: 'Cessna 172RG'  },
  { ident: 'N5143U',  year: 1980, model: 'Cessna 172RG'  },
  { ident: 'N52891',  year: 1981, model: 'Cessna 172P'   },
  { ident: 'N5346V',  year: 1980, model: 'Cessna 172RG'  },
  { ident: 'N6216R',  year: 1979, model: 'Cessna 172RG'  },
  { ident: 'N6425V',  year: 1980, model: 'Cessna 172RG'  },
  { ident: 'N6461V',  year: 1980, model: 'Cessna 172RG'  },
  { ident: 'N65275',  year: 1982, model: 'Cessna 172P'   },
  { ident: 'N698MC',  year: 1998, model: 'Cessna 182S'   },
  { ident: 'N733BD',  year: 1976, model: 'Cessna 172N'   },
  { ident: 'N7371',   year: 1998, model: 'Cessna 182S'   },
  { ident: 'N9508B',  year: 1981, model: 'Cessna 172RG'  },
  { ident: 'N959BW',  year: 1981, model: 'Cessna R182'   },
  { ident: 'N98853',  year: 1998, model: 'Cessna 182S'   },
]
